import { useState, useEffect } from 'react';
import RetentionTab from '../components/RetentionTab';
import TargetingTab from '../components/TargetingTab';
import CohortsTab from '../components/CohortsTab';
import ImpactTab from '../components/ImpactTab';
import { fetchRegions } from '../lib/api';

export default function Dashboard({ brands, meta, onSignOut }) {
  const [tab, setTab] = useState('retention');
  const [regions, setRegions] = useState([]);
  const [filters, setFilters] = useState({
    group: 'ALL',           // 'ALL' | 'OWN' | 'P3'
    brand: 'ALL',           // 'ALL' or a brand name
    channel: 'Omni',        // 'Omni' | 'Retail' | 'E-Commerce'
    category: 'ALL',        // 'ALL' | 'FOOD' | 'TREATS'
    region: 'ALL',          // 'ALL' or a state
  });

  useEffect(() => { fetchRegions().then(r => setRegions(r.data || [])); }, []);

  const entityKey = (() => {
    if (filters.group === 'ALL') return 'ALL';
    if (filters.brand === 'ALL') return filters.group === 'OWN' ? 'OWN_ALL' : 'P3_ALL';
    return `${filters.group}_${filters.brand}`;
  })();

  const setF = (patch) => setFilters(f => ({ ...f, ...patch }));

  const brandOptions = filters.group === 'ALL'
    ? []
    : (filters.group === 'OWN' ? brands.own : brands.p3);

  return (
    <>
      <div className="banner">
        <div className="brand">
          <div className="logo">H</div>
          <div>
            <h1>Retention Command Center</h1>
            <div className="subtitle">
              6 customer segments · Food + Treats · brand + channel + category targeting · data through {meta.asof_date}
            </div>
          </div>
        </div>
        <div className="actions">
          <button onClick={onSignOut}>Sign out</button>
        </div>
      </div>

      <div className="filter-bar">
        <div className="filter-group">
          <span className="filter-label">Group</span>
          <select className="filter-select" value={filters.group}
                  onChange={e => setF({ group: e.target.value, brand: 'ALL' })}>
            <option value="ALL">All</option>
            <option value="OWN">Own brand</option>
            <option value="P3">3P</option>
          </select>
        </div>
        <div className="filter-group">
          <span className="filter-label">Brand</span>
          <select className="filter-select" value={filters.brand}
                  onChange={e => setF({ brand: e.target.value })}
                  disabled={filters.group === 'ALL'}>
            <option value="ALL">All brands</option>
            {brandOptions.map(b => <option key={b} value={b}>{b}</option>)}
          </select>
        </div>
        <div className="filter-group">
          <span className="filter-label">Channel</span>
          <select className="filter-select" value={filters.channel} onChange={e => setF({ channel: e.target.value })}>
            <option value="Omni">Omni</option>
            <option value="Retail">Retail</option>
            <option value="E-Commerce">E-Commerce</option>
          </select>
        </div>
        <div className="filter-group">
          <span className="filter-label">Category</span>
          <select className="filter-select" value={filters.category} onChange={e => setF({ category: e.target.value })}>
            <option value="ALL">All categories</option>
            <option value="FOOD">Food only</option>
            <option value="TREATS">Treats only</option>
          </select>
        </div>
        <div className="filter-group">
          <span className="filter-label">Region</span>
          <select className="filter-select" value={filters.region} onChange={e => setF({ region: e.target.value })}>
            <option value="ALL">All regions</option>
            {regions.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      </div>

      <div className="tabs">
        {[
          ['retention', 'Retention'],
          ['targeting', 'Targeting'],
          ['cohorts',   'Cohort detail'],
          ['impact',    'Program impact'],
        ].map(([k, label]) => (
          <button key={k} className={`tab ${tab === k ? 'active' : ''}`} onClick={() => setTab(k)}>{label}</button>
        ))}
      </div>

      <div className="tabview">
        {tab === 'retention' && <RetentionTab filters={filters} entityKey={entityKey} />}
        {tab === 'targeting' && <TargetingTab filters={filters} entityKey={entityKey} />}
        {tab === 'cohorts'   && <CohortsTab   filters={filters} entityKey={entityKey} />}
        {tab === 'impact'    && <ImpactTab    filters={filters} />}
      </div>
    </>
  );
}
